import { render, staticRenderFns } from "./PageTab.vue?vue&type=template&id=02f194cc&"
import script from "./PageTab.vue?vue&type=script&lang=js&"
export * from "./PageTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports